/**
 * TrustGate Background Layout Component
 * 
 * Provides consistent background gradient and layout structure
 * across all TrustGate console pages and workspaces.
 */

import React from 'react';

interface BackgroundLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const BackgroundLayout: React.FC<BackgroundLayoutProps> = ({ 
  children, 
  className = "" 
}) => {
  return (
    <div className={`min-h-screen bg-gradient-to-br from-[#0a0a0f] via-[#1a1a2e] to-[#16213e] text-white ${className}`}>
      {children}
    </div>
  );
};
